import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../services/hooks.service';
import { getBlockchainByWhId, getEvmChainId, isEvmChain } from '../wallets/providers';
import { EVMContractServices } from '../services/contract.services';
import { updateUserEVMBalances } from '../redux/_actions/user.action';

export const useEVMBalance = (asset: { index: string | number, chainId?: number }, isOn: boolean) => {

  const walletAddress = useAppSelector((state) => state.user.activeAddress);
  const appChain = useAppSelector(state => state.network.chain);
  const blockchain = getBlockchainByWhId(String(asset.chainId));
  const chainId = blockchain && getEvmChainId(blockchain);
  const isEVM = Boolean(chainId) && isEvmChain(appChain);
  const dispatch = useAppDispatch();
  const evmBalance = useAppSelector((state) => state.user.userBalances[`${asset.index}_${asset.chainId}`]);

  useEffect(() => {
    if (isOn && isEVM) {
      if(!evmBalance || ((Date.now() - evmBalance.timestamp.getTime()) > 10000)) {
        EVMContractServices.getEVMBalance(asset.index as `0x${string}`, walletAddress, chainId)
        .then(balance => {
          const assetKey = `${asset.index}_${asset.chainId}`;
          dispatch(updateUserEVMBalances({[assetKey]: {address: walletAddress, balance, timestamp: new Date()}}));
        })
        .catch(err => console.log(err));
      }
    }
  }, [asset, evmBalance, isOn, walletAddress]);
};
